import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {DisplayMessageChatEventNode} from 'llm/data-capture/DataCaptureTypes';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {GRAY_LIGHTER} from 'ui-library/Colors';

export interface DataCaptureUserMessageBubbleProps {
  event: DisplayMessageChatEventNode;
}

export default function DataCaptureUserMessageBubble({
  event,
}: DataCaptureUserMessageBubbleProps): JSX.Element {
  const messageText = event.messageBlocks.map((block) => block.text).join('\n');
  return (
    <div className={css(styles.userMessageLayout)} data-testid="user-message-bubble">
      <div className={css(styles.userMessageContainer)}>{messageText}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  userMessageLayout: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  userMessageContainer: {
    padding: '12px',
    maxWidth: '80%',
    backgroundColor: GRAY_LIGHTER,
    borderRadius: '4px',
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  },
});
